<template>
    <div class="area_section" v-if="state.data != null && state.data.length > 0">
        <div class="area_contents">
            <div class="area_contents_title">
                <p v-text="state.headerData.title"></p>
            </div>

            <div class="area_contents_body">
                <table class="areaGrid">
                    <thead>
                        <tr>
                            <th scope="col" v-for="item in state.headerData.types" v-html="item"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="year in years" :key="year">
                            <tr>
                                <td v-text="year" rowspan="2"></td>
                                <td v-for="key in state.headerData.keys">
                                    {{ CommonUtils.numberFormat(CommonUtils.getCntByCnAndYear(year, key, state.data)) }}
                                </td>
                                <td rowspan="2" v-if="state.headerData.title !== '실인원'">
                                    {{
                                        CommonUtils.numberFormat(
                                            state.headerData.keys.reduce(
                                                (sum: number, t: number) => sum + CommonUtils.getCntByCnAndYear(year, t, state.data),
                                                0,
                                            ),
                                        )
                                    }}
                                </td>

                                <td rowspan="2" v-else>
                                    {{
                                        Math.round(
                                            (CommonUtils.getCntByCnAndYear(year, 999, state.data) /
                                                CommonUtils.getCntByCnAndYear(year, 998, state.data)) *
                                                10000,
                                        ) /
                                            100 +
                                        "(%)"
                                    }}
                                </td>
                            </tr>

                            <tr>
                                <td v-for="key in state.headerData.keys" v-if="state.headerData.title !== '실인원'">
                                    {{
                                        CommonUtils.getCntByCnAndYear(year, key, state.data) > 0
                                            ? (
                                                  (CommonUtils.getCntByCnAndYear(year, key, state.data) /
                                                      state.headerData.keys.reduce(
                                                          (sum: number, t: number) => sum + CommonUtils.getCntByCnAndYear(year, t, state.data),
                                                          0,
                                                      )) *
                                                  100
                                              ).toFixed(2) + "%"
                                            : 0
                                    }}
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="area_section" v-else></div>
</template>

<script lang="ts" config>
    import { reactive, onMounted, types, getMessageByCode, CommonUtils, CommonOptions, watch } from "@/BaseComponent";

    export default {
        props: {
            data: { type: Array<types.statistics.StatisticsYearVOForApi>, default: {} },
            years: { type: Array<number>, default: [] },
            headerData: { type: Object, default: {} },
        },
        components: {},
        setup(props: any) {
            const state = reactive({
                data: [] as Array<types.statistics.StatisticsYearVOForApi>,
                years: [] as Array<number>,
                headerData: {} as any,
            });

            onMounted(() => {
                state.data = props.data;
                state.years = props.years;
                state.headerData = props.headerData;
            });

            watch(props, () => {
                state.data = props.data;
                state.years = props.years;
                state.headerData = props.headerData;
            });

            return {
                state,
                CommonUtils,
            };
        },
    };
</script>
<style scoped>
    .areaGrid td {
        text-align: center;
        vertical-align: middle;
    }
</style>
